import { cloneDeep } from "lodash";

import {
  get,
  options,
  destroyForm,
  post,
  patch,
  getPagination,
  getAllFetchProcessName,
  getFiltered,
} from "../../base";
import { getSingleFetchProcessName } from "../../base/utils";
import constants from "./constants";
import { store } from "../../store";
import { createUploadHandler } from "./uploadHandler";

export const getAll = () => {
  return get({
    url: constants.LIST_URL,
    constants,
    name: getAllFetchProcessName(),
  });
};

export const getSingle = (id) => {
  const url = `${constants.GET_URL}${id}`;
  return get({ url, constants, name: getSingleFetchProcessName(id) });
};

export const performFilter = (
  querystring,
  callback,
  taskToken,
  initiatedBySocket
) => {
  const url = `${constants.LIST_URL}?${querystring}`;
  return getFiltered({
    url,
    constants,
    querystring,
    callback,
    taskToken,
    initiatedBySocket,
  });
};

export const filterPagination = (querystring) => {
  const url = `${constants.LIST_URL}?${querystring}`;
  return getPagination({ url, constants, querystring });
};

export const getPostForm = () => {
  return options({ url: constants.POST_URL, constants, method: "POST" });
};

export const destroyPostForm = (success) => {
  return destroyForm({ constants, method: "POST", success });
};

export const getPatchForm = (id) => {
  const url = `${constants.PATCH_URL}${id}`;
  return options({ url, constants, method: "PATCH" });
};

export const destroyPatchForm = (success) => {
  return destroyForm({ constants, method: "PATCH", success });
};

export const create = ({
  processSuccess,
  processError,
  successCallback,
  errorCallback,
}) => {
  const preProcess = (data) => {
    const dataClone = cloneDeep(data);

    if (dataClone.image_temp_data) {
      delete dataClone.image_temp_data;
    } else if (dataClone.image) {
      delete dataClone.image;
    }
    return dataClone;
  };

  const uploadCallback = async (responseData, dispatch) => {
    const state = store.getState();
    const formInstance = state[constants.STORE_NAME].formInstance;

    await createUploadHandler({ formInstance, responseData, dispatch });

    return;
  };

  return post({
    url: constants.POST_URL,
    constants,
    preProcess,
    processSuccess,
    processError,
    successCallback,
    errorCallback,
    uploadCallback,
  });
};

export const update = ({
  id,
  processSuccess,
  processError,
  successCallback,
  errorCallback,
}) => {
  const preProcess = (data) => {
    const dataClone = cloneDeep(data);

    if (dataClone.image_temp_data) {
      delete dataClone.image_temp_data;
    } else if (dataClone.image) {
      delete dataClone.image;
    }

    dataClone.next_invoice_number = null;

    return dataClone;
  };

  const uploadCallback = async (responseData, dispatch) => {
    const state = store.getState();
    const formInstance = state[constants.STORE_NAME].formInstance;

    await createUploadHandler({ formInstance, responseData, dispatch });

    return;
  };
  const url = `${constants.PATCH_URL}${id}`;
  return patch({
    url,
    constants,
    preProcess,
    processSuccess,
    processError,
    successCallback,
    errorCallback,
    uploadCallback,
  });
};
